/**
 * The pre-authentication screen.
 *
 * It renders before the router mounts, so it deliberately shares nothing with
 * the rest of the app — a failure loading the runtime configuration must still
 * produce something readable.
 */
export function Splash({
  message,
  tone = "info",
}: {
  message: string;
  tone?: "info" | "error";
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-backdrop bg-fixed px-6">
      <div className="max-w-md text-center">
        <p
          className={
            tone === "error"
              ? "rounded-lg border border-red-400/40 bg-red-950/40 px-4 py-3 text-sm text-red-200"
              : "text-sm text-chrome/70"
          }
        >
          {message}
        </p>
      </div>
    </div>
  );
}
